<script setup lang="ts">
import type { PropType } from 'vue'
import type MenuItem from '../../../type/MenuItem'

const { menuItem } = defineProps({
  menuItem: {
    type: Object as PropType<MenuItem>,
    required: true
  }
})
</script>
<template>
  <div flex="~ row" w-full cursor-pointer items-center py-2.5 text-main context-menu-item>
    <i ml-3 v-if="menuItem.icon != undefined" :class="menuItem.icon" text-xl></i>
    <div ml-3 grow text-base>
      {{ menuItem.name }}
    </div>
  </div>
</template>
<style scoped></style>
